import { Card, CardText, CardHeader, RaisedButton } from 'material-ui';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import HeaderSmall from '../Components/Header/HeaderSmall';

class DeleteAccountPage extends React.Component {
    constructor(props){
        super(props);
    }


    openMailTo = () => {

        let message = `I wish to formally request that my account be deleted from your system. My registered email address is ${this.props.member.EmailAddress}`;
        let email = `mailto:support@medefy.com?subject=Account%20Deletion%20Request&body=${message}`

        if(window.device && window.device.platform){
            if(window.device.platform.toLowerCase() === 'ios' || window.device.platform.toLowerCase() === 'android'){
            //console.log("Mail To:", email);
            window.cordova.InAppBrowser.open(email,"_system")
            } else {
                //web app for testing
                window.open(email, "_system");
            };
        } else {
            //web app for testing
            window.open(email, "_system");
        };
    }

    render(){

        return (
            <div>
                <HeaderSmall title="Delete Account" />
                <div className={'container'}>
                <Card>
                    <CardText>
                    <div style={{paddingLeft: 15}}>
                    <h4>Account Deletion</h4>
                    <br />
                    <h3>Are you sure you want to delete your account? <p style={{fontSize:16, color:'red'}}>This action is permanent.</p></h3>
                        <ul className={'list-text'}>
                            <li>When you click the "Delete My Account" button, the app will create an email that is addressed to our support team.</li>
                            <li>You may review the email and add additional comments before sending it.</li>
                            <li>Once our support team recieves your request, they will contact you to confirm your request.</li>
                            <li>Upon your confirmation, the account will be permanently deleted from our system, and you will be notified that the action has been completed.</li>
                        </ul>
                        </div>
                    </CardText>
                    <div style={{padding:'20px 50px 50px 50px'}}>
                    <RaisedButton secondary={true} label={'Delete My Account'} fullWidth={true} onClick={this.openMailTo}></RaisedButton>
                    <div style={{height:20}}>&nbsp;</div>
                    <RaisedButton primary={true} label={'Go Back'} fullWidth={true} containerElement={<Link to={'account/'} />}/>
                    </div>
                </Card>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})


export default connect(
  mapStateToProps
)(DeleteAccountPage)


// WEBPACK FOOTER //
// ./src/Pages/DeleteAccount.js